import { useState } from 'react';
import { DragUpdate } from 'react-beautiful-dnd';

const queryAttr = 'data-rbd-draggable-id';

export const useDragAndDrop = () => {
    const [placeholderProps, setPlaceholderProps] = useState<any>({});
    const onDragEnd = () => {
        setPlaceholderProps({});
    };

    const dragCss = {
        transform: 'rotate(2deg)',
        boxShadow: '0px 4px 12px rgb(0 0 0 / 10%)',
    };

    const placeholderCss = {
        position: 'absolute',
        top: placeholderProps.clientY,
        left: placeholderProps.clientX,
        height: placeholderProps.clientHeight,
        width: placeholderProps.clientWidth,
        background: '#e8e9ea',
    };

    const onDragUpdate = (update: DragUpdate) => {
        if (!update.destination) {
            setPlaceholderProps({});
            return;
        }

        const draggableId = update.draggableId;
        const destinationIndex = update.destination.index;

        const domQuery = `[${queryAttr}='${draggableId}']`;
        const draggedDOM = document.querySelector(domQuery);

        const parentNode = draggedDOM?.parentNode as any;

        if (!draggedDOM || !parentNode) {
            return;
        }
        const { clientHeight, clientWidth } = draggedDOM;

        const clientY =
            parseFloat(window.getComputedStyle(draggedDOM).marginTop) +
            parseFloat(window.getComputedStyle(parentNode).paddingTop) +
            [...parentNode.children].slice(0, destinationIndex).reduce((total, curr) => {
                const style = curr.currentStyle || window.getComputedStyle(curr);
                const marginBottom = parseFloat(style.marginBottom);
                const marginTop = parseFloat(style.marginTop);

                return total + curr.clientHeight + marginBottom + marginTop;
            }, 0);

        setPlaceholderProps({
            clientHeight,
            clientWidth,
            clientY,
            clientX: parseFloat(window.getComputedStyle(parentNode).paddingLeft),
        });
    };

    return {
        placeholderCss,
        dragCss,
        onDragUpdate,
        onDragEnd,
        placeholderProps,
    };
};
